import { render, staticRenderFns } from "./EditSeriesApproval.vue?vue&type=template&id=588275dc"
import script from "./EditSeriesApproval.vue?vue&type=script&lang=js"
export * from "./EditSeriesApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports